export const tabFocusedStyles = (params?: {offset: string}) => `
  outline: auto Highlight;
  outline: auto -webkit-focus-ring-color;
  outline-offset: ${params?.offset ?? '0'};
`;
